import type {
  APILibraryTemplatePackRequestType,
  APILibraryTemplatePackResponseType,
} from "@/core/data_sources/models/APILibraryTemplatePack";
import type {
  APILibraryTemplateInstallRequestType,
  APILibraryTemplateInstallResponseType,
} from "@/core/data_sources/models/APILibraryTemplateInstallation";
import type { BasicQuery } from "@/core/data_sources/services";
import { get, patch, post } from "@/core/utils/request";

export function getTemplatePacks<Q extends BasicQuery>(query: Q) {
  return get<APILibraryTemplatePackResponseType[]>("/library/packs/", {
    params: query,
  });
}
export function getTemplatePackById(id: string | number) {
  return get<APILibraryTemplatePackResponseType>(`/library/packs/${id}/`);
}
export type TemplatePackDetailQuery = BasicQuery & {
  id: string | number;
};
export function getTemplatePackByQuery<Q extends TemplatePackDetailQuery>(
  query: Q,
) {
  return getTemplatePackById(query.id);
}
export function postTemplatePack(data: APILibraryTemplatePackRequestType) {
  return post<
    APILibraryTemplatePackRequestType,
    APILibraryTemplatePackResponseType
  >("/library/packs/", data);
}
export function patchTemplatePack(
  id: string | number,
  data: APILibraryTemplatePackRequestType,
) {
  return patch<
    APILibraryTemplatePackRequestType,
    APILibraryTemplatePackResponseType
  >(`/library/packs/${id}/`, data);
}
export function installLibraryTemplates(
  data: APILibraryTemplateInstallRequestType,
) {
  return post<
    APILibraryTemplateInstallRequestType,
    APILibraryTemplateInstallResponseType
  >("/library/install-templates/", data);
}

export function installTemplatePack(packUrl: string) {
  return installLibraryTemplates({ packs: [packUrl] });
}

export function installTemplate(templateUrl: string) {
  return installLibraryTemplates({ templates: [templateUrl] });
}
